__turbopack_context__.v({
  "buttons": "styles-module__HgOlVa__buttons",
});
